import TitleSection from '../../components/page-layout/title-section';
import style from './orders-batches.module.less';
import GridTitle from '../../components/grid-header/grid-header-title';
import BatchDetailNameEdit from '../../components/batches/batch-detail-name-edit';
import BatchNote from '../../components/batches/batch-note';
import React from 'react';
import PropTypes from 'prop-types';
import { ADVANCED_SEARCH_ID, ADVANCED_SEARCH_VIEW } from '../orders-page/orders-page-view-constants';
import { useSelectedOrdersViewId } from '../orders-page/orders-left-nav/orders-left-nav-context';

const OrdersBatchesGridTitle = ({ batch }) => {
  const viewId = useSelectedOrdersViewId();
  const ordersPageIsOnAdvancedSearchView = viewId === ADVANCED_SEARCH_ID;
  if (ordersPageIsOnAdvancedSearchView) {
    return (
      <TitleSection className={style['view-name']}>
        <GridTitle view={ADVANCED_SEARCH_VIEW} />
      </TitleSection>
    );
  }
  return (
    <TitleSection>
      <BatchDetailNameEdit batch={batch} />
      <BatchNote assignedToGuid={batch.assignedToGuid} batchId={batch.fulfillmentPlanSetId} name={batch.name} note={batch.note} />
    </TitleSection>
  );
};

OrdersBatchesGridTitle.propTypes = {
  batch: PropTypes.shape({
    fulfillmentPlanSetId: PropTypes.string,
    name: PropTypes.string,
    note: PropTypes.string,
    assignedToGuid: PropTypes.string,
  }).isRequired,
};

export default OrdersBatchesGridTitle;
